import React, { Component } from 'react'
import FixedView from '../FixedView'
import Collapsible from 'react-collapsible'
import { checkPermission, checkTranslation, getAppletsAndhubsFromFramesList, imageAddress, translate } from '../../utils/useful'
import FramesPlusBut from './FramesPlusBut'
import IntractionActionsList from '../IntractionActionsList'
import importedIcons from '../inputs/icons';
import HttpServices from '../../utils/Http.services'
import PortalScopeTreeView from './PortalScopeTreeView'

export default class PortalScopeSelector extends Component {
    state = {
        collapses: {},
        hierarchy: []
    }

    componentDidMount() {

        this.init()
    }

    init() {
        let data = {}
        data.frameType = this.props.type

        HttpServices.request('getMyFramesByType', data, (fetchResult, fetchError) => {

            if (fetchError) {
                return
            }
            let frames = fetchResult.frames ?? []
            let hierarchy = []

            getAppletsAndhubsFromFramesList(frames, (hubs, applets) => {

                // console.log(hubs, applets, frames)

                for (let h = 0; h < hubs.length; h++) {
                    const hub = hubs[h];
                    let temp = hub
                    temp.children = []
                    temp['type*'] = 'hub'
                    for (let a = 0; a < applets.length; a++) {
                        const applet = applets[a];
                        // console.log(applet, hub)
                        if (applet.hub?._id == hub._id) {
                            let appletFrames = frames.filter((a) => a.applet?._id == applet._id)

                            for (let f = 0; f < appletFrames.length; f++) {
                                let appletFrame = appletFrames[f];
                                appletFrame['type*'] = 'frame'
                            }

                            temp.children.push({
                                ...applet,
                                ...{
                                    children: appletFrames,
                                    'type*': 'applet'
                                }
                            })

                        }
                    }
                    hierarchy.push(temp)

                }
                // console.log(hierarchy)

                this.setState({ hierarchy, frames, hubs, applets, currentAppletName: null })


            })



        })

    }

    // changeCollapse = (key) => {
    //     let collapses = this.state.collapses
    //     collapses[key] = this.state.collapses[key] == null ? false : !this.state.collapses[key]
    //     this.setState({ collapses })
    // }

    changeScope = (item, type) => {
        // this.props.changePage(item)
        // console.log('item is', item)
        this.setState({ currentScope: item ? { item, type } : null }, () => {

            this.props.functionsHandler(null, 'changeScope', { item, type })
            this.framesOptionsList.hideView()

        })
    }

    handelFunction = (mfunction) => {
        if (this[mfunction]) {
            this[mfunction]()
        }
    }

    addPage = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'pages', 'new'])
        this.framesOptionsList.hideView()
    }

    addCollection = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'collections', 'new'])
        this.framesOptionsList.hideView()
    }



    iconSelector(type) {
        switch (type) {
            case 'collection':
                return '/assets/icons/applets/database.png'

            case 'messenger':
                // /assets/icons/applets/messenger.png
                return '/assets/icons/portals/chat (2).png'

            case 'drive':
                return '/assets/icons/applets/drive.png'

            case 'folder':
                return '/assets/icons/folder (1).png'

            case 'page':
                return '/assets/icons/applets/notebook.png'



            default:
                return '/assets/icons/useful/pages.png'
        }
    }



    showChildren = (parent, data, level) => {
        return (
            <div className={''}>

                {data?.map((item, index) => {
                    // console.log('item.parents',item.parents[item.parents.length - 1],parent,item)
                    // if (item.parents &&
                    //     (checkPermission(this.props.permissions, `collection.${item._id}.view`)) &&
                    // item.parents[item.parents.length - 1] == parent && !item.hideInDashboard && item.userperspective)
                    // item.parents[item.parents.length - 1] == parent && !item.hideInDashboard && !item.userperspective) {

                    let hasChildren = item.children?.length > 0

                    return (
                        <div className={'w-100 ' + (level > 0 ? ' pld-2' : '')} key={index}>
                            <div className='flexcb w-100 p-2 hover-gray-no-filter br-5  transition-all'>
                                <div className={"flexcb w-100 "}>
                                    <button onClick={() => { this.changeScope(item, item['type*']) }} className='flexc w-100'>



                                        <div className='flexcc pld-1'>
                                            <img className="transition-all br-20 image-cover" src={item.image ? imageAddress(item.image, item['type*'], 'mini') : (item['type*'] == 'applet' ? imageAddress(item.image, 'applet', 'mini') : this.iconSelector(item.type))} height={20} width={20} alt='' />
                                        </div>


                                        <div className={'mld-3'}>
                                            <p className='font-size-12 text-semibold main-c3 '>{checkTranslation(item.title ?? item.name)}</p>
                                        </div>
                                    </button>
                                    <div>
                                        {hasChildren && (
                                            <div className="flexcc" >
                                                {/* <FramesPlusBut width={this.props.width} colors={this.props.colors} frame={item._id} functionsHandler={this.props.functionsHandler} updateFrames={this.props.updateFrames} variables={this.props.variables} /> */}
                                                <button onClick={() => this.changeCollapse(item._id)}>
                                                    <img className={"transition flexcc " + ((this.state.collapses[item._id] == null || this.state.collapses[item._id] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' alt='' />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* <div className={'w-100 ' + ((this.state.collapses[item._id] == null ? true : this.state.collapses[item._id]) ? "Collapsible-is-open" : '')}> */}
                            <Collapsible open={this.state.collapses[item._id] == null ? true : this.state.collapses[item._id]}>
                                {this.showChildren(item._id, item.children, level + 1)}
                            </Collapsible>
                            {/* </div> */}
                        </div>
                    )
                    // }
                })}
            </div>
        )
    }



    render() {

        let colors = this.props.colors
        let currentScope = this.state.currentScope
        let scopeInfo = { image: null, name: null }

        if (currentScope?.item) {

            scopeInfo.image = imageAddress(currentScope.item?.image, currentScope.item['type*'], 'mini')
            scopeInfo.name = checkTranslation(currentScope.item?.fullname ?? currentScope.item.name)

            if (!currentScope.item?.image && currentScope.item['type*'] == 'frame') {
                scopeInfo.image = this.iconSelector(currentScope.item?.type)
            }


        } else {
            scopeInfo = { image: "/assets/icons/applets/database/frame-white.svg", name: translate('Full Scope') }
        }

        return (
            <div>

                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2' style={{ maxWidth: 120 }}>
                    <div className={'flexcc pld-2 prd-3 py-1 br-5 w-100 ' + (colors?.iconInvert ? "dark-blur-bg" : 'light-blur-bg')}>
                        <div className='flexcc mrd-2'>
                            <img className={'br-20 ' + (colors?.iconInvert ? 'invert' : '')} width={18} height={18} src={scopeInfo?.image} alt='' />
                        </div>
                        <div className='flex-1' style={{ minWidth: 0 }}>
                            <p className='font-size-13 text-semibold w-100' style={{ color: colors.textColor, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{scopeInfo?.name}</p>
                        </div>
                    </div>
                </button>

                <FixedView width={this.props.width} zIndex={40} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={this.props.language == 'fa' ? 170 : -9} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3  ' >

                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>

                            <PortalScopeTreeView changeScope={this.changeScope} hierarchy={this.state.hierarchy} />

                        </div>
                        {/* <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                                <div style={{ borderBottom: '1px solid #eee' }}>
                                    <button onClick={() => this.changeScope(null)} className='flexc w-100 p-2 hover-gray2 br-5 mb-2' >
                                        <div className="flexc">
                                            <img className="transition" src={'/assets/icons/useful/infinite.png'} width={22} />
                                            <div className='d-flex flex-column mld-3'>
                                                <p className={'font-size-12 text-semibold main-c3'}>{translate("Full scope")}</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>

                                <div className='py-1'>
                                    {this.state.hierarchy?.map((section, i) => {
                                        let checkParent
                                        if (section.parents && section.parents.length != 0) {

                                            this.props.frames.map((sec) => {
                                                if (section.parents.includes(sec._id)) {
                                                    checkParent = true
                                                }
                                            })
                                        }

                                    
                                        let show = true

                                        if (show) {

                                            let hasAdd = true
                                            let hasChildren = section.children?.length > 0

                                            return (
                                                <div key={section._id} className="w-100 " style={{ borderBottom: '0px solid #f6f6f6' }}>
                                                    <div className="flexcb w-100 px-2   hover-gray-no-filter br-5  transition-all "  >
                                                        <button onClick={() => this.changeScope(section, section['type*'])} className="py-2 flexc text-start flex-1">
                                                            <img className="transition-all br-20" src={imageAddress(section.image, 'profile', 'mini')} width={22} height={22} alt='' style={{ objectFit: 'cover' }} />
                                                            <div className='mld-3'>
                                                                <p className="font-size-12 main-c3 text-bold " style={{}}>{section.fullname}</p>
                                                            </div>
                                                        </button>

                                                        <div className='flexc'>

                                                            {hasChildren && (
                                                                <button className="" onClick={() => this.changeCollapse(section._id)}>
                                                                    <img className={"transition flexcc " + ((this.state.collapses[section._id] == null || this.state.collapses[section._id] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' alt='' />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <Collapsible open={this.state.collapses[section._id] == null ? true : this.state.collapses[section._id]}>
                                                        {this.showChildren(section._id, section.children, 1)}
                                                    </Collapsible>
                                                </div>
                                            )
                                        }
                                    })}
                                </div>
                        </div> */}
                    </div>
                </FixedView>
            </div>
        )
    }
}
